<template>
  <!--
    BEGIN::Modified.by.KWShin.2024.08.30.
    motletOptions에 추가적인 설정을 통합하여 전달.
  -->
  <!--motlet-neo :options="motletOptions" dense-->
  <motlet-neo :options="mergedMotletOptions" dense>
    <!-- FINISH::Modified.by.KWShin.2024.08.30. -->
    <template v-slot:content="{ props }">
      <!-- eslint-disable-next-line prettier/prettier -->
      <!--
        BEGIN:: Modified.by.KWShin.2023.07.25.
        sstmId를 잘못 넘겨주어서, 좌상단 시스템 선택기에서 시스템 선택이 바뀌었을 때
        field-selectable-grid로 바뀐 sstmId가 전달되지 않아
        데이터 조회가 정상적으로 이루어지지 않는 문제가 있다.
      -->
      <!--field-selectable-grid
        :sstmId="props.motlet.descendant.systemId"
        :code="props.motlet.settings.grid.code"
        :event-code="props.motlet.settings.grid.eventCode"
        :selected="props.motlet.settings.grid.selectedFields"
        :height="params.height"
        :timestamp="timestamp"
        :clickRow="clickRow"
        :onFetch="onFetch"
        :items.sync="items"
      /-->
      <!-- eslint-disable-next-line prettier/prettier -->
      <field-selectable-grid
        :sstmId="params.sstmId"
        :code="props.motlet.settings.grid.code"
        :event-code="props.motlet.settings.grid.eventCode"
        :selected="props.motlet.settings.grid.selectedFields"
        :height="params.height"
        :timestamp="timestamp"
        :clickRow="clickRow"
        :onFetch="onFetch"
        :items.sync="items"
      />
      <!-- END:: Modified.by.KWShin.2023.07.25.-->
    </template>
  </motlet-neo>
</template>

<script>
// Added.by.KWShin2024.08.30.
import { merge } from 'lodash';
import FieldSelectableGrid from '../../../components/abap/FieldSelectableGridNeo';

export default {
  components: {
    FieldSelectableGrid,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
    timestamp: {
      type: Number,
      required: true,
    },
    clickRow: {
      type: Function,
      default() {
        return function() {};
      },
    },
    // BEGIN::Added.by.2023.06.21.KWShin.
    onFetch: {
      type: Function,
      default() {
        return function() {};
      },
    },
    // FINISH::Added.by.2023.06.21.KWShin.
  },
  data() {
    return {
      motletOptions: {
        id: 'detailview/abap/dumpLog/abapDump/DumpGrid',
        title: 'abapdump.grid.title',
        settings: { grid: { use: true, code: 'G_ABAP_DUMP', eventCode: 'ABAP_DUMP' } },
        descendant: {
          systemId: this.params.sstmId,
        },
      },
      items: [],
    };
  },
  computed: {
    // BEGIN::Added.by.KWShin.2024.08.30.
    // 기존의 motletOptions에 params를 통해 넘어온 motletOptions 옵션을 통합하여 준다.
    mergedMotletOptions() {
      return merge({}, this.motletOptions, this.params.motletOptions);
    },
    // FINISH::Added.by.KWShin.2024.08.30.
  },
  methods: {},
};
</script>
